module.exports = __webpack_public_path__ + "static/img/logo-header_1.b785b3a7.png";